import { useCallback, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DefaultFilterNum } from "./constants";
import { FilterFormProps, FilterFormValues } from "./types";
import { getOperationLabelMappings, sanitizeValues } from "./utils";

export const useFilterForm = (props: FilterFormProps) => {
  const {
    variant: { type, maxFilterNum },
    filterOperations,
    close,
    onSave,
  } = props;
  const { setValue, handleSubmit } = useFormContext<FilterFormValues>();
  const { t } = useTranslation();

  const labelMappings = getOperationLabelMappings(t);

  const filterOptions = useMemo(
    () =>
      filterOperations.map((operation) => ({
        id: operation,
        label: labelMappings[operation],
      })),
    [t, filterOperations],
  );

  const onClear = useCallback(() => {
    setValue(
      "values",
      Array.from({ length: maxFilterNum ?? DefaultFilterNum }, () => ["", ""]),
    );
    close();
  }, [setValue, close, maxFilterNum]);

  const sanitizedOnSave = useCallback(
    (values: FilterFormValues) => {
      const sanitizedValues = sanitizeValues(values, type);
      onSave(sanitizedValues);
    },
    [onSave, type],
  );

  const onSubmit = handleSubmit(sanitizedOnSave);

  return { filterOptions, onClear, onSubmit };
};
